<template>
  <div class="row no-margin-bottom" v-if="currentUser.SystemRoleId > 1">
    <div class="col s12 users">

      <!-- Remove user modal -->
      <div id="removeUserModal" class="modal">
        <div class="modal-content" v-if="selectedUser">
          <h4>Delete user {{ selectedUser.FirstName }} {{ selectedUser.MiddleName }} {{ selectedUser.LastName }}</h4>
          <p>Are you sure you want to delete this user account?</p>
        </div>
        <div class="modal-footer">
          <a href="#!" class="modal-close waves-effect waves-green btn-flat" @click="selectedUser = undefined">cancel</a>
          <a href="#!" class="modal-close waves-effect waves-green btn-flat" @click="removeUser()">remove</a>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <p style="margin-bottom: 0px">Users</p>
        </div>
      </div>
      <div class="row">
        <div class="col s5">
          <a
            class="waves-effect waves-light btn"
            style="min-width: 150px"
            :disabled="isPublishing"
            @click="navigateNewUser()">
              New user
          </a>
          <a
            class="waves-effect waves-light btn"
            v-if="currentUser.SystemRoleId === 3"
            style="min-width: 150px"
            @click="publishAllActiveUsers"
            :disabled="isPublishing"
          >
            <span v-if="!isPublishing">Sync all active users</span>
            <span v-else>
              <i class="material-icons left spinning-icon">autorenew</i>Syncing...
            </span>
          </a>
          <a
            class="waves-effect waves-light btn"
            v-if="currentUser.SystemRoleId === 3"
            style="min-width: 150px"
            @click="publishAllAlarmNotifications"
            :disabled="isSyncing"
          >
            <span>{{ syncText }}</span>
          </a>
        </div>
        <div class="col s3">
        </div>
        <div class="col s2">
          <div class="input-field" v-if="currentUser.SystemRoleId === 3">
            <select v-model="organisationFilter.selectedOption" @change="setPagingParameters()">
              <option v-for="(value, index) in organisationFilter.options" v-bind:key="index">{{value}}</option>
            </select>
            <label>Organisation filter</label>
          </div>
        </div>
        <div class="col s2">
          <div class="input-field active">
            <input v-model="searchText" placeholder="Search by name" id="first_name" type="text" class="validate" @keyup="allUsersFilter(), setPagingParameters()">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col s12">
          <table class="striped">
            <thead>
              <tr>
                <th @click="orderUsersByFilter('Email')" class="clickable">Email
                  <i :style="{ color: orderUsersBy.activeColumn === 'Email' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th @click="orderUsersByFilter('FirstName')" class="clickable">First name
                  <i :style="{ color: orderUsersBy.activeColumn === 'FirstName' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th @click="orderUsersByFilter('LastName')" class="clickable">Last name
                  <i :style="{ color: orderUsersBy.activeColumn === 'LastName' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th @click="orderUsersByFilter('Organisation.OrganisationName')" class="clickable">Organisation
                  <i :style="{ color: orderUsersBy.activeColumn === 'Organisation.OrganisationName' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                 <th @click="orderUsersByFilter('UserStatus')" class="clickable">UserStatus
                  <i :style="{ color: orderUsersBy.activeColumn === 'UserStatus' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th @click="orderUsersByFilter('SystemRoleId')" class="clickable">Role
                  <i :style="{ color: orderUsersBy.activeColumn === 'SystemRoleId' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th @click="orderUsersByFilter('LastLoginDatetime')" class="clickable">Last login
                  <i :style="{ color: orderUsersBy.activeColumn === 'LastLoginDatetime' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th @click="orderUsersByFilter('AccountExpires')" class="clickable">Expiration date
                  <i :style="{ color: orderUsersBy.activeColumn === 'AccountExpires' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderUsersBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th>Edit</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(user, index) in allUsersFilter()" v-bind:key="index"
                  v-show="index + 1 <= (paging.itemsPerPage * paging.selectedPage) &&
                  index + 1 > ((paging.itemsPerPage * paging.selectedPage) -paging.itemsPerPage)"
                  >
                <td @click="navigateEditUser(user)" class="clickable">{{ user.Email }}</td>
                <td @click="navigateEditUser(user)" class="clickable">{{ user.FirstName }}</td>
                <td @click="navigateEditUser(user)" class="clickable">{{ user.LastName }}</td>
                <td @click="navigateEditUser(user)" class="clickable">{{ user.Organisation.OrganisationName }}</td>
                <td @click="navigateEditUser(user)" class="clickable">{{ translateUserStatus(user.UserStatus) }}</td>
                <td @click="navigateEditUser(user)" class="clickable">{{ translateRole(user.SystemRoleId) }}</td>
                <td @click="navigateEditUser(user)" class="clickable">{{ formatDateTime(user.LastLoginDatetime) }}</td>
                <td v-if="formatDateToUtc(user.AccountExpires) < currentDate" @click="navigateEditUser(user)" class="clickable" style="color: #C91414"><i class="material-icons left">warning</i> account has expired</td>
                <td v-else @click="navigateEditUser(user)" class="clickable">{{ formatDate(user.AccountExpires) }}</td>
                <td v-if="currentUser.UserId !== user.UserV61id" class="center-align"><i class="material-icons clickable modal-trigger" href="#removeUserModal" @click="selectedUser = user">delete_forever</i></td>
                <td v-else class="center-align">-</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul class="pagination center-align" v-if="paging.enabled">
          <li
            :class="{ disabled: paging.selectedPage === 1, 'waves-effect': paging.selectedPage > 1 }"
            @click="paging.selectedPage !== 1 && paging.selectedPage--">
            <i class="material-icons">chevron_left</i>
          </li>

          <li
            v-for="(pageNumber, index) in paging.numberOfPages" v-bind:key="index"
            class="waves-effect"
            :class="{ active: paging.selectedPage == pageNumber }"
            @click="paging.selectedPage = pageNumber"
          >
            <a>{{ pageNumber }}</a>
          </li>

          <li :class="{ disabled: paging.selectedPage === paging.numberOfPages, 'waves-effect': paging.selectedPage < paging.numberOfPages }"
            @click="paging.selectedPage !== paging.numberOfPages && paging.selectedPage++">
            <i class="material-icons">chevron_right</i>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script>
import Router from '@/router'
import _ from 'lodash'
import moment from 'moment'
import UsersApi from '@/services/api/UsersApi'
import AuthenticationService from '@/services/AuthenticationService'
import NotificationsService from '@/services/r8/NotificationsService'
import AssetsApi from '@/services/api/AssetsApi'

export default {
  data: function () {
    return {
      currentUser: AuthenticationService.getUser(),
      currentDate: this.formatDateToUtc(new Date()),
      allUsers: undefined,
      selectedUser: undefined,
      isPublishing: false,
      isSyncing: false,
      syncText: 'Sync all notifications',
      searchText: '',
      orderUsersBy: {
        activeSortingDirection: 'desc',
        activeColumn: undefined
      },
      organisationFilter: {
        options: ['All'],
        selectedOption: 'All'
      },
      paging: {
        enabled: true,
        itemsPerPage: 20,
        numberOfPages: 0,
        selectedPage: 1,
        chevronLeftActive: false,
        chevronRightActive: false
      },
      emptyUserModel: {
        FirstName: '',
        UserDepartment: []
      }
    }
  },
  mounted: function () {
    this.getAllUsersAndSetOrganisationsDropdown()
    M.Modal.init(document.querySelectorAll('.modal'), { dismissible: false })

    // Initialize select boxes
    M.FormSelect.init(document.querySelectorAll('select'))
  },
  methods: {
    removeUser: function () {
      UsersApi.deleteUser(this.selectedUser.UserV61id).then(() => {
        this.$notify({
          group: 'alerts',
          type: 'success',
          title: 'Delete user',
          text: 'User is removed successfully'
        })
        this.getAllUsersAndSetOrganisationsDropdown()
      }).catch(e => {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Delete user',
          text: 'Unknown error occured'
        })
      })
    },
    translateRole: function (role) {
      switch (role) {
        case 3:
          return 'Super'
        case 2:
          return 'Admin'
        case 1:
          return 'User'
      }
    },
    translateUserStatus: function (role) {
      switch (role) {
        case -1:
          return 'Deleted'
        case 0:
          return 'InActive'
        case 1:
          return 'Active'
      }
    },
    getAllUsersAndSetOrganisationsDropdown: function () {
      UsersApi.getUsers().then(result => {
        this.allUsers = _.orderBy(result.data, 'Email', ['asc'])
        this.organisationFilter.options = _.uniq(_.map(result.data, 'Organisation.OrganisationName'))
        this.organisationFilter.options.push('All')
        this.organisationFilter.options = _.orderBy(this.organisationFilter.options)
      }).then(() => {
        this.setPagingParameters()
        this.orderUsersByFilter('FirstName')
      })
    },
    allUsersFilter: function () {
      if (this.allUsers !== undefined) {
        var allUsersFiltered = _.filter(this.allUsers, o => {
          if (_.includes((o.FirstName !== undefined ? o.FirstName : '').toLowerCase(), this.searchText.toLowerCase()) ||
           _.includes((o.LastName !== undefined ? o.LastName : '').toLowerCase(), this.searchText.toLowerCase())) {
            return o
          }
        })

        return allUsersFiltered.filter(f => {
        // Show all if no filters are set
          if (this.organisationFilter.selectedOption === 'All') {
            return f
          }

          if (this.organisationFilter.selectedOption !== 'All' && this.organisationFilter.selectedOption !== null && this.organisationFilter.selectedOption !== undefined) {
            return f.Organisation.OrganisationName === this.organisationFilter.selectedOption
          }
        })
      }
    },
    orderUsersByFilter: function (columnName) {
      this.orderUsersBy.activeColumn = columnName
      if (this.orderUsersBy.activeSortingDirection === 'asc') {
        this.orderUsersBy.activeSortingDirection = 'desc'
        this.allUsers = _.orderBy(this.allUsers, columnName, ['desc'])
      } else {
        this.orderUsersBy.activeSortingDirection = 'asc'
        this.allUsers = _.orderBy(this.allUsers, columnName, ['asc'])
      }
    },
    setPagingParameters: function () {
      this.paging.selectedPage = 1
      this.paging.numberOfPages = Math.ceil(this.allUsersFilter().length / this.paging.itemsPerPage)
    },
    formatDateToUtc: (date) => {
      return moment.utc(date).format()
    },
    formatDateTime: (dateTime) => {
      if (dateTime === null) {
        return 'Hasn\'t logged in'
      }
      return moment(String(dateTime)).format('DD-MM-YYYY HH:mm')
    },
    formatDate: (dateTime) => {
      if (dateTime === null) {
        return 'Expiration date not set'
      }
      return moment(String(dateTime)).format('DD-MM-YYYY')
    },
    navigateEditUser: function (userObject) {
      Router.push({
        name: 'user',
        params: {
          id: userObject.UserV61id
        }
      })
    },
    navigateNewUser: function () {
      Router.push({
        name: 'new-user'
      })
    },
    publishAllActiveUsers: async function () {
      this.isPublishing = true
      try {
        await UsersApi.publishAllActiveUsers()
        this.$notify({
          group: 'alerts',
          type: 'success',
          title: 'Sync Users',
          text: 'All active users synchronized successfully.'
        })
      } catch (e) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Sync Failed',
          text: 'Error while synchronizing users: ' + e.message
        })
      } finally {
        this.isPublishing = false
      }
    },
    publishAllAlarmNotifications: async function () {
      this.isSyncing = true
      let i = 1

      if (this.allUsers) {
        for (const u of this.allUsers) {
          try {
            this.syncText = `Syncing ${i}/${this.allUsers.length}...`
            const alarmSettings = (await UsersApi.getUserAlarmSettings(u.UserV61id)).data // PR-894

            let assets = await AssetsApi.getFiltered(
              alarmSettings.RegionIds,
              alarmSettings.DepartmentIds,
              alarmSettings.ComplexIds
            )

            // Create a distinct list of asset ids
            const assetIds = assets.data
              .map(item => item.UniqueId)
              .filter(id => id)

            // Save alarm settings to R8
            await NotificationsService.postNotifications(
              u.Email,
              assetIds
            )
          } catch (e) {
            let errorMessage = 'Unknown error occurred'
            if (e.response && e.response.data) {
              errorMessage = typeof e.response.data === 'string'
                ? e.response.data
                : e.response.data.message || JSON.stringify(e.response.data)
            } else if (e.message) {
              errorMessage = e.message
            }

            this.$notify({
              group: 'alerts',
              type: 'error',
              title: 'Sync Failed',
              text: `Error while synchronizing notifications for user ${u.Email}: ${errorMessage}`
            })
          } finally {
            i++
          }
        }
      }

      this.syncText = 'Sync all notifications'
      this.isSyncing = false
    }
  }
}
</script>

<style scoped>
td {
  padding: 3px;
}

p {
  margin-top: 24px;
  margin-bottom: 24px;
}

/* BUTTON */
.btn-floating:hover {
  background-color: #F39810;
}

.btn:hover, .btn-large:hover, .btn-small:hover {
  background-color: #F39810;
}

.btn, .btn-large, .btn-small {
  background-color: #56CCF2;
}

.users {
  background-color: white;
  height: calc(100vh - 56px);
  overflow-y: auto;
}

.spinning-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
 }
}
</style>



// WEBPACK FOOTER //
// src/pages/users/Users.vue